import { carList } from "@/mocks/carListData";

interface ConfirmModalProps {
  show: boolean;
  selectedId: number | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmModal({ show, selectedId, onCancel, onConfirm }: ConfirmModalProps) {
  if (!show) return null;

  const selectedCar = carList.find((c) => c.id === selectedId);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.4)" }}>
      <div className="bg-white rounded-t-3xl w-full p-6" style={{ maxWidth: 480 }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mb-5" />
        <div className="text-lg font-bold text-gray-800 mb-2">替换当前租车方案？</div>
        <div className="text-sm text-gray-500 mb-6">
          将替换为「{selectedCar?.model}」，套餐价格将同步更新。
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap"
            style={{ background: "#F3F4F6", color: "#6B7280" }}
          >
            取消
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap"
            style={{ background: "#1E3A8A" }}
          >
            确认替换
          </button>
        </div>
      </div>
    </div>
  );
}
